import * as React from "react";
import { Link as GatsbyLink } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Text,
  VStack
} from "@chakra-ui/react";


interface Props {
  node: any
}


export const Service: React.FC<Props> = ( props ) => {
  return (
    <Flex
      direction={{
        base: 'column',
        lg: 'row'
      }}
      alignItems={{
        lg: 'center'
      }}
      gap={{
        base: '24px',
        lg: '0'
      }}
    >
      <Box
        minW={{
          lg: '490px',
          xl: '687px'
        }}
        w={{
          lg: '490px',
          xl: '687px'
        }}
        background="linear-gradient(to right, #F1F5FB 0%, #F1F5FB 75%, white 75%, white 100%)"
        padding={{
          base: '24px',
          md: '100px',
          lg: '50px',
          xl: '100px'
        }}
      >
        <Image
          as={ GatsbyImage }
          image={ props.node.frontmatter.image.childImageSharp.gatsbyImageData }
        />
      </Box>
      <VStack
        justify="flex-start"
        align="flex-start"
        spacing="24px"
      >
        <Heading
          as="h4"
          color="text.primary"
          fontSize="20px"
          fontWeight={ 700 }
        >
          <Text
            as="span"
            color="primary.900"
            fontWeight={ 700 }
          >
            ~
          </Text>
          &nbsp;
          { props.node.frontmatter.subheading }
        </Heading>
        <Heading
          as="h3"
          color="text.primary"
          fontSize="48px"
          fontWeight={ 700 }
        >
          { props.node.frontmatter.heading }
        </Heading>
        <Text
          color="text.secondary"
        >
          { props.node.frontmatter.description }
        </Text>
        <Box>
          <Button
            as={ GatsbyLink }
            to={ props.node.fields.slug }
            variant="link"
            color="primary.900"
            _hover={{
              opacity: '0.6',
              textDecoration: 'none'
            }}
          >
            Learn more
          </Button>
        </Box>
      </VStack>
    </Flex>
  )
}
